var map = {
	"./pt-br": 210,
	"./pt-br.js": 210
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1045;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale pt-br
// module id = 1045
// module chunks = 17